import React from 'react';
import { SvgProps } from '../../../models/components/svg';
import { Brands } from '../../../models/brands';
import { BrandStyling } from '../../../theme/brandStyling';

const BackIcon: React.FC<SvgProps> = ({ className, brandId = Brands.URocked }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        className={className}
    >
        <path
            d="M7.14645 14.707L0.146447 7.70703C-0.0488155 7.51177 -0.0488155 7.19526 0.146447 7L7.14645 0L7.85348 0.707031L1.20699 7.35352L7.85348 14L7.14645 14.707Z"
            fill={BrandStyling.byBrand(brandId).backIconFill}
        />
        <path d="M14.5 6.85352V7.85352H0.999962V6.85352H14.5Z" fill={BrandStyling.byBrand(brandId).backIconFill} />
    </svg>
);

export default BackIcon;
